import React, { useState } from 'react';
import './Enrouler.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

type EnroulerProps = {
  title: string;
  children: React.ReactNode;
};

const Enrouler: React.FC<EnroulerProps> = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen((prev) => !prev);

  return (
    <div className="toggle-section">
      <div className="toggle-header" >
        <h4 onClick={toggle}>{title} 
            <div className={`toggle-button ${isOpen ? 'open' : ''}`} >
              <FontAwesomeIcon icon={isOpen ? faMinus : faPlus} />
            </div>
        </h4>
        
      </div>
      {isOpen && <div className="toggle-content">{children}</div>}
    </div>
  );
};

export default Enrouler;
